import React, { useState } from "react";
import Popup from "./Popup/Popup";
import { usePromo } from "../../providers/Init";
import { useTranslation } from "react-i18next";

const Section = ({ products }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const promo = usePromo();
  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  // Function to close the popup
  const closePopup = () => {
    setSelectedProduct(null);
  };

    const { t, i18n } = useTranslation();
  return (
    <div className="grid flex-wrap w-full max-w-screen-lg grid-cols-2 gap-4 mx-auto overflow-hidden gap-y-4">
      {products.map((product) => (
        <div
          key={product.id}
          onClick={() => handleProductClick(product)}
          className="flex flex-col w-full p-4 overflow-hidden bg-white border-b border-gray-100 shadow h-fit "
        >
          {/* Left Section: Product Details */}
          <div className="flex-shrink-0 h-full pr-2 aspect-square">
            <img
              src={`${product.image}`}
              className="object-cover w-full h-full rounded-xl"
              alt={product.name}
            />
          </div>
          <div className="flex flex-col flex-1 px-2 pr-2 ">
            <span className="font-semibold text-gray-800 truncate">
              {product.name}
            </span>
            {/* <span className="w-full my-2 text-sm text-gray-500 line-clamp-2">
  {product.description}
</span> */}
            <div className="flex flex-col">
              <span className="text-xs text-[#eb1c26] opacity-50 line-through">
                {t("SR")} {product.price}
              </span>
              <div className="flex items-center gap-x-4">
                <span className="flex items-center mr-2 text-sm text-neutral-600 gap-x-1">
                  {t("SR")}{" "}
                  <span className="font-semibold text-neutral-800">
                    {(parseFloat(product.price) * promo).toFixed(2)}
                  </span>
                </span>
                <span className="mr-2 text-sm text-[#471c09] font-semibold">
                  {product.calories} {t("Calories")}
                </span>
              </div>
            </div>

          </div>

          {/* Right Section: Product Image */}

          {/* Action Button */}
        </div>
      ))}

      {selectedProduct && (
        <Popup selectedProduct={selectedProduct} closePopup={closePopup} />
      )}
    </div>
  );
};

export default Section;
